import React, { useMemo } from "react";
import * as S from "./Breadcrumb.styles";
import { BreadcrumbCollapser } from "./BreadcrumbCollapser";
import { BreadcrumbItem } from "./BreadcrumbItem";
import { Link, BreadcrumbLinkProps } from "./Link";
import type { BreadcrumbItemProps } from "./BreadcrumbItem";

export type BreadcrumbProps = {
  items: BreadcrumbItemProps[];
  itemsBeforeCollapse?: number;
  itemsAfterCollapse?: number;
  maxItems?: number;
  LinkComponent?: React.ComponentType<BreadcrumbLinkProps>;
};

export const Breadcrumb = ({
  items = [],
  itemsBeforeCollapse = 1,
  itemsAfterCollapse = 3,
  maxItems = 4,
  LinkComponent = Link
}: BreadcrumbProps) => {
  const breadcrumbItems = useMemo(() => {
    const totalItems = items.length;
    let steps = items.map(({ to, label, onClick }, index) => {
      const isLast = items.length === index + 1;

      return (
        <BreadcrumbItem
          to={to}
          label={label}
          key={index}
          isActive={isLast}
          onClick={onClick}
          LinkComponent={LinkComponent}
        />
      );
    });

    if (totalItems > maxItems) {
      steps = [
        ...steps.slice(0, itemsBeforeCollapse),
        <BreadcrumbCollapser
          key={`item-${itemsBeforeCollapse + 1}`}
          title="Expand"
        />,
        ...steps.slice(totalItems - itemsAfterCollapse, totalItems)
      ];
    }
    return steps;
  }, [items, itemsBeforeCollapse, itemsAfterCollapse, maxItems, LinkComponent]);

  return <S.BreadcrumbWrapper>{breadcrumbItems}</S.BreadcrumbWrapper>;
};
